import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
// import { Http } from '@angular/http';
// import { AppConfig } from '../app.config';
import { Restangular } from 'ngx-restangular';
//import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService {
  title = 'Kavana Ekub';
  baseApi: string;

  constructor(@Inject(Restangular) public Restangular,
  ) {
    this.baseApi = environment.production
      ? environment.ONLINE_BASE_URL.substring(0, environment.ONLINE_BASE_URL.length - 4) :
      environment.LOCAL_BASE_URL.substring(0, environment.LOCAL_BASE_URL.length - 4);
  }

  public authenticate(auth: any) {
    debugger;
    return this.Restangular.oneUrl('auth', this.baseApi + 'api/oauth/token').customPOST(auth);
  }

  public getLoggedInUser() {
    debugger;
    return this.Restangular.one('users/user/current').customGET('');
  }
}
